import {Component} from "react";
import styled from "styled-components";
import GlobalMessages from "messages/messages";
import {FormattedMessage} from "react-intl";
import * as PropTypes from "prop-types";
import LoadingAnimation from "../../basicComponents/LoadingAnimation/LoadingAnimation";
import {Typography} from "@material-ui/core";

export default class ScannersAvailable extends Component {
  static propTypes = {
    total: PropTypes.number,
    available: PropTypes.number,
  };

  static defaultProps = {
    total: 0,
    available: 0,
  };

  render() {
    return <></>
    return (
      <Wrapper>
        <Content>
          <WrapperText>
            <Typography variant="caption">
              <FormattedMessage {...GlobalMessages.scannersAvailable} />
            </Typography>
          </WrapperText>
          {this.props.total !== 0 && (
            <div>
              {`${this.props.available} `} / {`${this.props.total} `}
            </div>
          )}
          {this.props.total === 0 && (
            <LoadingAnimation size={8} contained/>
          )}
        </Content>
      </Wrapper>
    );
  }
}

const WrapperText = styled.div`
  margin-left: 10px;
`;
const Wrapper = styled.div`
  width: 7rem + 1px;
  border-left: 1px solid ${({ theme }) => theme.borderColor};
  border-right: 1px solid ${({ theme }) => theme.borderColor};
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius};
  transform : translate(-1px,-5px);
`;

const Content = styled.div`
  z-index: 9999999;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 10px;
  padding-top: 10px;
`;
